import { render } from "./RegistryDatatableEditableField.vue?vue&type=template&id=44efea5d&scoped=true&ts=true"
import script from "./RegistryDatatableEditableField.vue?vue&type=script&lang=ts"
export * from "./RegistryDatatableEditableField.vue?vue&type=script&lang=ts"

import "./RegistryDatatableEditableField.vue?vue&type=style&index=0&id=44efea5d&scoped=true&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44efea5d"]])

export default __exports__